import { ObjectId } from 'bson';

export const generateObjectId = () => {
    return new ObjectId().toString();
};